import { Avatar } from '@chakra-ui/react'
import { AuthedAvatarImage } from './AuthedAvatarImage'

interface PersonAvatarProps {
  name: string
  /** A portrait URL. Missing, or failing to load (404, offline), it falls back to initials, never a broken image. */
  src?: string | null
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl'
}

/** [Canvasser redesign Phase 7] The one avatar for grant photos (canvasser + staff surfaces). Semantic tokens only. */
export function PersonAvatar({ name, src, size = 'sm' }: PersonAvatarProps) {
  return (
    <Avatar.Root size={size} bg="accent.soft" color="accent" flexShrink={0}>
      <Avatar.Fallback name={name} />
      {src ? <AuthedAvatarImage src={src} alt="" /> : null}
    </Avatar.Root>
  )
}
